import { keyframes } from "@mui/material/styles";

/**
 * Shared motion primitives for the `/tester` under-construction surface,
 * extracted from `TesterPage.tsx`. Reuses the dashboard's established motion
 * vocabulary (the `riseIn` entrance + radar ping from AgentHero / PulseHeader)
 * so the page reads as one designed system. Every consumer pairs these with
 * `[REDUCED]: { animation: "none" }` so motion-averse users get the static
 * layout.
 */

/* One-shot entrance — pure transform + opacity, exponential ease-out. */
export const riseIn = keyframes({
  from: { opacity: 0, transform: "translateY(8px)" },
  to: { opacity: 1, transform: "translateY(0)" },
});

/* Radar "ping" — a ring expands outward from the node and fades. */
export const ping = keyframes({
  "0%": { transform: "scale(0.42)", opacity: 0.55 },
  "70%": { opacity: 0 },
  "100%": { transform: "scale(2.6)", opacity: 0 },
});

/* The live-status dot — a quiet breath, not a blink. */
export const breathe = keyframes({
  "0%, 100%": { opacity: 1, transform: "scale(1)" },
  "50%": { opacity: 0.35, transform: "scale(0.82)" },
});

/* Indeterminate progress — a bright segment sweeps across the track. */
export const sweep = keyframes({
  "0%": { transform: "translateX(-120%)" },
  "100%": { transform: "translateX(320%)" },
});

/** Media query for the `prefers-reduced-motion` opt-out. */
export const REDUCED = "@media (prefers-reduced-motion: reduce)";
